module.exports = __webpack_public_path__ + "img/domains-step-1.ru.4c80aa21.png";